import React, { ReactNode, useMemo } from "react";
import { IStyle, mergeStyles } from "@fluentui/react";
import { sidePaneContentWrapperStyles, sidepaneItemStyle } from "../styles/SidepaneItem.styles";
import { useTheme } from "@azure/communication-react";
import { SidepaneItemHeader } from "./SidepaneItemHeader";
import { selectIsMobile, usePcpLiveLessonContext } from "../store";


export interface SidepaneItemProps {
    children: ReactNode;
    isOpen: boolean;
    headerText?: string|ReactNode;
    closeButtonText: string;
    close?: () => void;
    styles?: {root?:IStyle};
}

export const SidepaneItem = ({
    children,
    headerText,
    closeButtonText,
    isOpen,
    close,
    styles,
}: SidepaneItemProps): JSX.Element => {
    const themeV8 = useTheme();
    const contentClassName = useMemo(
        () => mergeStyles(sidePaneContentWrapperStyles(themeV8))
    , [themeV8]);
    const isMobile = usePcpLiveLessonContext(selectIsMobile);

    const displayStyles = useMemo(() => ({ display: isOpen ? "" : "none" }), [isOpen]);

    return (
        <div
            style={displayStyles}
            className={mergeStyles(sidepaneItemStyle(themeV8, isMobile), styles?.root)}
        >
            <SidepaneItemHeader closeButtonText={closeButtonText} close={close} >
                {headerText}
            </SidepaneItemHeader>

            <div className={contentClassName}>
                {children}
            </div>
        </div>
    );
}
